import { MatDialogRef } from '@angular/material/dialog';
import {Component, OnInit} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';

@Component({
    selector: 'app-loan-agreement-component',
    templateUrl: './loanAgreement.component.html',
    styleUrls: ['./loanAgreement.component.css']
})
export class LoanAgreementComponent implements OnInit {
    constructor(private dialogRef: MatDialogRef<LoanAgreementComponent>, private storageService: StorageService) {
    }

    ngOnInit(): void {
        this.storageService.removeObjectFromSession(Keys.LENDER_LOAN_AGREEMENT_REVIEWED);
    }

    onAgreementAccepted() {
        this.dialogRef.close(Result.ACCEPTED);
        this.storageService.saveObjectToSession(Keys.LENDER_LOAN_AGREEMENT_REVIEWED, true);
    }
}

export enum Result {
    ACCEPTED
}
